// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__3G_iU","colorRect":"Category_colorRect__3n8uD","name":"Category_name__3JX-p"};